import { InspectorField } from "../../../../../../library-templates/inspector/fields/InspectorField";
import { InspectorLibrary } from "../../../../../../library-templates/inspector/InspectorLibrary";
import { SlicingMode, SlicingModeType } from "./SlicingMode";
import { MusicKey } from "../../../../../../library-js/audio/music/MusicKey";
import { MusicNote } from "../../../../../../library-js/audio/music/MusicNote";
import { ExportNamingMode, ExportNamingModeType } from "./ExportNamingMode";
import { EnumValue } from "../../../../../../library-templates/inspector/types/EnumValue";
import { List } from "../../../../../../library-templates/inspector/types/List";
import { CallbackButton } from "../../../../../../library-templates/inspector/types/CallbackButton";
import { AudioEditor } from "../../AudioEditor";
import { ClipExport } from "./ClipExport";
import { TrimmingOptions } from "./TrimmingOptions";



export class ExportSettings
{
  slicing = new SlicingMode();
  trimming = new TrimmingOptions();
  naming = new ExportNamingMode();
  exports = new List<ClipExport>( ClipExport );
  logSettings = new CallbackButton();
  sliceClips = new CallbackButton();
  exportAllClips = new CallbackButton();
}